module.exports = __webpack_public_path__ + "static/media/loading.4a70fd5a.gif";